import React from "react";
import { styled } from "styled-components";
import { Color } from "../../../theme/Color";
import { Font } from "../../../theme/Font";
import { Link } from "react-router-dom";
import { SectionTitle } from "../../DesignComponent/DesignComponents";
import he from 'he';
const Hero = ({data}) => {
  return (
    <>
      <Section80 className="blog-hero-sec text-white position-relative" style={{ backgroundColor: Color.theme_first }}>
        <div className="container p-auto">
          <div className="d-flex flex-wrap ">
            <div className="col-md-5 col-12 mb-md-0 mb-4 pe-md-4 pe-0">
              <div className="d-flex mb-2 gap-2 flex-wrap">
                {data?.categories?.map((item, index) => (
                  <Categorybtn
                    to={{
                      pathname: `/category/?name=${item?.slug}`,
                      state: { item },
                    }}
                    key={index}
                    className="category-name me-3"
                  >
                    {item?.name}
                  </Categorybtn>
                ))}
              </div>
              {data?.title && (
                <SectionTitle className="my-4">{he.decode(data?.title)}</SectionTitle>
              )}
              <div className="w-75">
                <hr className="m-0" />
                <div className="d-flex justify-content-between py-md-3 py-2">
                  <SmallTitle className="m-0">Published </SmallTitle>
                  <SmallText className="m-0">{data?.published_date}</SmallText>
                </div>
                <hr className="m-0" />
                <div className="d-flex justify-content-between py-md-3 py-2">
                  <SmallTitle className="m-0">Reading Time</SmallTitle>
                  <SmallText className="m-0">{data?.reading_time}</SmallText>
                </div>
                <hr className="m-0" />
              </div>
            </div>
            <div className="col-md-7 col-12">
              {data?.featured_image && (
                <div className="blog-hero-img-wrapper img-wrapper">
                  <Image
                    className="feature-img banner-img"
                    src={data?.featured_image}
                    alt={data?.title}
                    // loading="lazy"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Section80>
    </>
  );
};

export default Hero;

const Section80 = styled.section`
  padding-top: 80px;
  padding-bottom: 80px;
  margin-bottom: 60px;
  background-color: ${Color.theme_four};
  @media (max-width: 767px) {
    padding-top: 40px;
    padding-bottom: 40px;
    margin-bottom: 0px;
  }
`;
const Categorybtn = styled(Link)`
  font-size: 14px;
  color: ${Color.theme_first};
  background-color: ${Color.beige};
  transition: all 1s;
  padding: 10px;
  text-decoration: none;
  border-radius: 2px;
  font-family: ${Font.basel};
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing:.078125rem;
  &:hover {
    color: ${Color.white};
    background-color: ${Color.theme_secound};
  }
`;
const Image = styled.img`
object-fit:cover;
  width: 100%;
  height: 100%;
  max-height: 600px;
  margin-bottom: -140px;
  @media (max-width: 767px) {
    margin-bottom: 0px;
  }
`;
const SmallTitle = styled.p`
  color: ${Color.theme_five};
  text-transform: uppercase;
  font-family: ${Font.regular};
`;
const SmallText = styled.p`
  font-family: ${Font.basel};
`;
